import type { HowToPlay } from '@puzzlio/core';

export const howToPlay: HowToPlay = {
  game: 'loopy-river',
  rules: () => [{ kind: 'line', line: 'Draw a single continuous loop (river!) that flows through every cell.' }],
  // No cycle strip: the river is drawn by dragging, not by tapping a cell through its states.
  gestures: ['Drag to draw and erase.', "Tap to mark an X where you know the loop won't flow."],
};
